module.exports = __webpack_public_path__ + "static/media/christmas-betlehem.02d8e299.jpg";